import React, { Component } from "react";
import Framework from "../framework/FrameworkComponents";
import UserDetails from "../framework/UserDetails";
import Button from "../framework/Button";
import webRootContext from "../components/webrootcontext/WebRootContext";

class FrameworksPage extends Component {
	 
	state = {
        patients: [],
        userProfile: [],
        error: "",
        query: ""
    };
	
/* The following 3 functions are needed to execute the getProperties function when the page loads.
   I'm not sure that these functions or getUserProfile are actually invoked anywhere, so we may
   want to delete them */
   
constructor(props) {
super(props);
this.getUserProfile = this.getUserProfile.bind(this);
}

componentDidMount() {
window.addEventListener('load', this.getUserProfile);
}



componentWillUnmount() {
window.removeEventListener('load', this.getUserProfile)
}
	
getUserProfile = () => {

   
	let userProfileURL = 	webRootContext + "/rest/usermanagement/get/userProfile";
	
	fetch(userProfileURL, {mode:"no-cors"})
      .then((response) => response.json())
      .then((data) => {

       this.setState({
         userProfile: data
       });
		
      }, (error) => {

          this.setState({
            isLoaded: true,
            error
          });
        });  

	  
  }; 

  render() {

    const {query, patients, userProfile} = this.state;

    console.log(patients);
    console.log(query);
	console.log("userId : " + userProfile.userId);
	
  return (
	<div className="BCHApp">
      <h2>Frameworks Components Page</h2>
	<Framework />
	<UserDetails/>
    <Button styleName="button button--primary  spacing" text="Get User Info" onClickFunction={this.getUserProfile} />
    </div>
    );
  }
}

export default FrameworksPage;